import { FormControl, Input, FormLabel, Flex } from "@chakra-ui/react";

const FormInput = ({
  labelText,
  inputType,
  name,
  value,
  handleChange,
  readOnly,
}) => {
  return (
    <Flex direction="column" width="100%" maxW="300px" mx="auto">
      <FormControl width="100%">
        <FormLabel color="headline.400" fontWeight="bold">
          {labelText}
        </FormLabel>
        <Input
          w="100%"
          maxW="300px"
          readOnly={readOnly}
          type={inputType}
          name={name}
          value={value}
          onChange={handleChange}
        />
      </FormControl>
    </Flex>
  );
};
export default FormInput;
